<template>
    <div class="page">
        <!-- 搜索 -->
        <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
            <el-form-item label="速度描述">
                <el-input  v-model="queryForm.speedName"></el-input>
            </el-form-item>
<!--            <el-form-item label="服务时长">-->
<!--                <el-input  v-model="queryForm.serviceHours"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="速度倍数">-->
<!--                <el-input  v-model="queryForm.speedMultiple"></el-input>-->
<!--            </el-form-item>-->
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-search" @click="getWashServiceSpeedList">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
            </el-form-item>
        </el-form>
        <div class="page-content">
            <div class="page-tool-bar">
                <div class="el-btn-group">
                    <el-button
                        type="primary"
                        size="small"
                        icon="el-icon-plus"
                        @click="addWashServiceSpeed"
                    >新建</el-button>
                    <el-button
                        type="warning"
                        plain
                        size="small"
                        icon="el-icon-edit"
                        :disabled="multipleSelection.length != 1"
                        @click="editWashServiceSpeed(null)"
                    >修改</el-button>
                    <el-button
                        type="danger"
                        plain
                        size="small"
                        icon="el-icon-delete"
                        :disabled="multipleSelection.length <= 0"
                        @click="deleteWashServiceSpeed(null)"
                    >删除</el-button>
                </div>

                <div class="icon-group">
                    <el-upload v-if="this.isImportDate"
                               class="upload-demo"
                               action="#"
                               :http-request="upload"
                               :show-file-list="true">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
                    </el-upload>
                    <span
                        title="搜索"
                        class="icon-box"
                        @click="search"
                    >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
                    <span
                        class="icon-box"
                        @click="refreshWashServiceSpeedList"
                    >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
                </div>
            </div>
            <!-- 列表数据 -->
            <el-table
                :data="washServiceSpeedList"
                row-key="id"
                border
                height="100%"
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                @selection-change="handleSelectionChange"
                size="small"
            >
                <el-table-column
                    align="center"
                    type="selection"
                    width="60"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="speedName"
                    label="速度描述"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="serviceHours"
                    label="服务时长"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="speedMultiple"
                    label="速度倍数"
                > </el-table-column>
                <el-table-column
                    :show-overflow-tooltip="true"
                    align="center"
                    prop="createTime"
                    label="创建时间"
                > </el-table-column>
                <el-table-column
                    fixed="right"
                    align="center"
                    label="操作"
                    width="300"
                >
                    <template slot-scope="scop">
                        <div class="operation">
                            <div @click="checkWashServiceSpeed(scop.row.id)">
                                <Icon size="16">
                                    <Eye24Regular />
                                </Icon>
                                <span class="operation-label">查看</span>
                            </div>
                            <div @click="editWashServiceSpeed(scop.row.id)">
                                <Icon size="16">
                                    <Edit24Regular />
                                </Icon>
                                <span class="operation-label">修改</span>
                            </div>
                            <div @click="deleteWashServiceSpeed(scop.row.id)">
                                <Icon size="16" style="color: red">
                                    <Delete24Regular />
                                </Icon>
                                <span class="operation-label" style="color: red">删除</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination
                    @size-change="sizeChange"
                    @current-change="currentChange"
                    :current-page.sync="currentPage"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalNum"
                    background
                    :pager-count="7"
                >
                </el-pagination>
            </div>
            <!-- 新增/查看/修改信息 -->
            <el-dialog
                :title="washServiceSpeedStates[washServiceSpeedState]"
                :visible.sync="showDialog"
                width="60%"
                @close="closeDialog"
            >
                <div>
                    <el-form
                        :model="washServiceSpeed"
                        ref="washServiceSpeedForm"
                        :rules="rules"
                        label-width="120px"
                        :inline="true"
                        size="small"
                    >
                        <el-form-item
                            label="速度描述"
                            prop="speedName"
                        >
                            <el-input
                                size="small"
                                v-model="washServiceSpeed.speedName"
                                :disabled="washServiceSpeedState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="服务时长"
                            prop="serviceHours"
                        >
                            <el-input
                                size="small"
                                v-model="washServiceSpeed.serviceHours"
                                :disabled="washServiceSpeedState == 'check'"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label="速度倍数"
                            prop="speedMultiple"
                        >
                            <el-input
                                size="small"
                                v-model="washServiceSpeed.speedMultiple"
                                :disabled="washServiceSpeedState == 'check'"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                </div>

                <div
                    slot="footer"
                    class="flex justify-end"
                >
                    <el-button @click="closeDialog">关闭</el-button>
                    <el-button
                        type="primary"
                        @click="submitForm"
                        v-if="washServiceSpeedState != 'check'"
                    >确定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetWashServiceSpeedList();
                this.getWashServiceSpeedList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetWashServiceSpeedList();
                this.getWashServiceSpeedList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            queryForm:{
                speedName: '', //速度描述
                serviceHours: '', //服务时长
                speedMultiple: '', //速度倍数
            },
            loading: false,
            showDialog: false,
            isImportDate: false,
            isSearch: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 0,
            currentUserId: '',
            washServiceSpeedState: 'add',
            washServiceSpeedStates: {
                add: '新建服务速度',
                check: '查看服务速度',
                edit: '修改服务速度'
            },

            multipleSelection: [],
            washServiceSpeedList: [],
            washServiceSpeed: {
                id: '', //ID
                speedName: '', //速度描述
                serviceHours: '', //服务时长
                speedMultiple: '', //速度倍数
                createTime: '', //创建时间
            },
            btnLoading: false,

            rules: {
                id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                speedName: [{ required: true, message: '速度描述不能为空', trigger: 'blur' }],
                serviceHours: [{ required: true, message: '服务时长不能为空', trigger: 'blur' }],
                speedMultiple: [{ required: true, message: '速度倍数不能为空', trigger: 'blur' }],
                createUserId: [{ required: true, message: '创建者不能为空', trigger: 'blur' }],
            }
        };
    },
    created() {
        this.getWashServiceSpeedList();
    },
    methods: {
        search(){
            this.isSearch = !this.isSearch;
        },
        resetWashServiceSpeedList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.washServiceSpeedList = [];
        },
        resetDialog() {
            this.washServiceSpeedState = 'add';
            this.showDialog = false;
            this.queryForm = {
                speedName: '', //速度描述
                serviceHours: '', //服务时长
                speedMultiple: '', //速度倍数
            };
            this.getWashServiceSpeedList();
        },
        closeDialog() {
            this.showDialog = false
            this.washServiceSpeed = {
                id: '', //ID
                speedName: '', //速度描述
                serviceHours: '', //服务时长
                speedMultiple: '', //速度倍数
                createTime: '', //创建时间
            };
        },
        submitForm() {
            if (this.washServiceSpeedState == 'add') {
                this.$refs.washServiceSpeedForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/wash/servicespeed/add`,{ ...this.washServiceSpeed }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000,
                                });
                                this.resetWashServiceSpeedList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            } else if (this.washServiceSpeedState == 'edit') {
                this.$refs.washServiceSpeedForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        post(`/wash/servicespeed/edit`,{ ...this.washServiceSpeed }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashServiceSpeedList();
                                this.resetDialog();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    }
                });
            }
        },
        addWashServiceSpeed() {
            this.showDialog = true;
            this.washServiceSpeedState = 'add';
        },
        checkWashServiceSpeed(washServiceSpeedId) {
            console.log(washServiceSpeedId);
            this.currentWashServiceSpeedId = washServiceSpeedId;

            this.getWashServiceSpeedById();
            this.showDialog = true;
            this.washServiceSpeedState = 'check';
        },
        editWashServiceSpeed(washServiceSpeedId) {
            console.log('washServiceSpeed', washServiceSpeedId);
            if (washServiceSpeedId) {
                this.currentWashServiceSpeedId = washServiceSpeedId;
                this.getWashServiceSpeedById();
            } else {
                this.washServiceSpeed = { ...this.washServiceSpeed, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.washServiceSpeedState = 'edit';
        },
        deleteWashServiceSpeed(washServiceSpeedId) {
            let ids = '';
            if (washServiceSpeedId) {
                ids = washServiceSpeedId;
            } else {
                ids = this.multipleSelection.map((washServiceSpeed) => washServiceSpeed.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteFun(`/wash/servicespeed/delete`,{ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: res.msg,
                                type: 'success',
                                duration: 2000
                            });
                            this.resetWashServiceSpeedList();
                            this.getWashServiceSpeedList();
                        } else {
                            this.$message({
                                message: res.msg,
                                type: 'error',
                                duration: 2000
                            });
                        }
                    });
                })
                .catch(() => {});
        },
        refreshWashServiceSpeedList() {
            this.resetWashServiceSpeedList();
            this.getWashServiceSpeedList();
        },
        getWashServiceSpeedList(query = {}) {
            this.loading = true;
            get(`/wash/servicespeed/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.washServiceSpeedList = res.page.list;
                    this.totalNum = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        getWashServiceSpeedById() {
            get(`/wash/servicespeed/get`,{ id: this.currentWashServiceSpeedId }).then((res) =>{
                if(res.success){
                    this.washServiceSpeed = { ...this.washServiceSpeed, ...res.washServiceSpeed };
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        /**
         * 导出信息
         */
        exportWashServiceSpeedList() {
            //this.btnLoading = true;
            exprotExcel(`/wash/servicespeed/export`, {...this.queryForm});
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/wash/servicespeed/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate;
        },
        upload(params){
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/wash/servicespeed/importData`,formData);
            this.refreshWashServiceSpeedList();
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getWashServiceSpeedList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getWashServiceSpeedList();
        }
    }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>